export const GET_CLAIMS = 'Claims/GET_CLAIMS';
export const GET_CLAIMS_SUCCESS = 'Claims/GET_CLAIMS_SUCCESS';
export const GET_CLAIMS_FAILED = 'Claims/GET_CLAIMS_FAILED';

export const GET_GW_CLAIMS = 'Claims/GET_GW_CLAIMS';
export const GET_GW_CLAIMS_SUCCESS = 'Claims/GET_GW_CLAIMS_SUCCESS';
export const GET_GW_CLAIMS_FAILED = 'Claims/GET_GW_CLAIMS_FAILED';

export const CREATE_CLAIM = 'Claims/CREATE_CLAIM';
export const CREATE_CLAIM_SUCCESS = 'Claims/CREATE_CLAIM_SUCCESS';
export const CREATE_CLAIM_FAILED = 'Claims/CREATE_CLAIM_FAILED';

export const UPDATE_CLAIM = 'Claims/UPDATE_CLAIM';
export const UPDATE_CLAIM_SUCCESS = 'Claims/UPDATE_CLAIM_SUCCESS';
export const UPDATE_CLAIM_FAILED = 'Claims/UPDATE_CLAIM_FAILED';

export const SUBMIT_CLAIM = 'Claims/SUBMIT_CLAIM';
export const SUBMIT_CLAIM_SUCCESS = 'Claims/SUBMIT_CLAIM_SUCCESS';
export const SUBMIT_CLAIM_FAILED = 'Claims/SUBMIT_CLAIM_FAILED';

export const CREATE_SHELL_CLAIM = 'Claims/CREATE_SHELL_CLAIM';
export const CREATE_SHELL_CLAIM_SUCCESS = 'Claims/CREATE_SHELL_CLAIM_SUCCESS';
export const CREATE_SHELL_CLAIM_FAILED = 'Claims/CREATE_SHELL_CLAIM_FAILED';
export const CREATE_SHELL_CLAIM_DUPLICATED = 'Claims/CREATE_SHELL_CLAIM_DUPLICATED';

export const CLEAR_ERRORS = 'Claims/CLEAR_ERRORS';
export const CLEAR_SHELL_CLAIM_DUPLICATED = 'Claims/CLEAR_SHELL_CLAIM_DUPLICATED';
